import { m } from "framer-motion";
import { Link as RouterLink } from "react-router-dom";
//import "@fontsource/poppins";
import "@fontsource/poppins/700";
// @mui
import { styled } from "@mui/material/styles";
import { ChevronLeft } from "@mui/icons-material";
import { Box, Button, Typography, Container } from "@mui/material";
// components
import Page from "../components/Page";
// assets

// ----------------------------------------------------------------------

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  minHeight: "100%",
  alignItems: "center",
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));



// ----------------------------------------------------------------------

export default function Page404() {
  return (
    <Page title="404 Page non trouvée" sx={{ height: 1 }}>
      <RootStyle>
        <Container>
          <Box sx={{ maxWidth: 480, margin: "auto", textAlign: "center" }}>
            {/* SVG with animation */}
            <img
              src="/statics/notFound.svg"
              alt="Page non trouvée"
              style={{ width: "100%", marginBottom: "20px" }}
            />

            <m.div>
              <Typography
               // variant="h3"
                paragraph
                sx={{
                  fontSize: "32px", // or any valid CSS size like '2rem'
                  fontFamily: "Poppins", // or any custom font
				 // fontHeight: "bold",
                }}
              >
                Page introuvable
              </Typography>
            </m.div>
            <Typography sx={{ color: "text.secondary" }}>
              La page que vous recherchez est introuvable. Veuillez vérifier
              l'URL ou retourner à la page précédente.
            </Typography>

            <m.div></m.div>

            <Box sx={{ mt: 5 }}>
              <Button
                to="/"
                size="large"
                variant="outlined"
                component={RouterLink}
                startIcon={<ChevronLeft />}
              >
                Retour vers la page d'accueil
              </Button>
            </Box>
          </Box>
        </Container>
      </RootStyle>
    </Page>
  );
}


// 